/* LoyaltyLion owns its data and DOM. This module only retires the static fallback. */
const region = document.querySelector('[data-loyalty-loading-region]');

if (region) {
  const content = region.querySelector('[data-loyalty-loading-content]');
  const skeleton = region.querySelector('[data-loyalty-loading-skeleton]');
  const fallback = region.querySelector('[data-loyalty-loading-fallback]');
  const status = region.querySelector('[data-loyalty-loading-status]');
  const retry = region.querySelector('[data-loyalty-loading-retry]');
  let queued = false;
  let visualDelay;
  let delayedStatus;
  let providerReady = false;
  const bootStartedAt = Number(region.loyaltyLoadingBoot?.startedAt);

  const ready = () => {
    const page = content?.querySelector('.lion-integrated-page');
    if (!page) return false;
    return [...page.querySelectorAll('.lion-header, .lion-integrated-page-section')]
      .some((section) => section.textContent.trim().length > 0);
  };

  const retireFallback = () => {
    if (skeleton) skeleton.hidden = true;
    if (fallback && !fallback.hidden && fallback.contains(document.activeElement)) {
      region.dataset.loyaltyLoadingState = 'ready-pending-focus';
      return;
    }
    if (fallback) fallback.hidden = true;
    region.dataset.loyaltyLoadingState = 'ready';
  };

  const update = () => {
    queued = false;
    if (!ready()) return;
    providerReady = true;
    clearTimeout(visualDelay);
    clearTimeout(delayedStatus);
    if (status) status.textContent = '';
    retireFallback();
  };

  const scheduleFallback = (startedAt = performance.now()) => {
    clearTimeout(visualDelay);
    clearTimeout(delayedStatus);

    visualDelay = setTimeout(() => {
      if (providerReady || ready()) {
        update();
        return;
      }
      if (skeleton) skeleton.hidden = false;
      region.dataset.loyaltyLoadingState = 'skeleton';
    }, Math.max(0, 140 - (performance.now() - startedAt)));

    delayedStatus = setTimeout(() => {
      if (providerReady || ready()) {
        update();
        return;
      }
      if (skeleton) skeleton.hidden = true;
      if (fallback) fallback.hidden = false;
      region.dataset.loyaltyLoadingState = 'delayed';
      if (status) {
        status.textContent = 'Rewards details are still connecting. You can try again or contact us for help.';
      }
    }, Math.max(0, 15000 - (performance.now() - startedAt)));
  };

  if (content) {
    new MutationObserver(() => {
      if (queued || providerReady) return;
      queued = true;
      requestAnimationFrame(update);
    }).observe(content, { childList: true, subtree: true });
  }

  fallback?.addEventListener('focusout', () => {
    if (!providerReady) return;
    requestAnimationFrame(retireFallback);
  });

  if (retry) retry.href = window.location.href;

  if (fallback) fallback.hidden = true;
  scheduleFallback(Number.isFinite(bootStartedAt) ? bootStartedAt : performance.now());
  update();
  region.dataset.loyaltyLoadingInitialized = 'true';
  region.loyaltyLoadingBoot?.observer?.disconnect();
  window.addEventListener('pagehide', () => {
    clearTimeout(visualDelay);
    clearTimeout(delayedStatus);
  });
  window.addEventListener('pageshow', () => {
    if (!ready()) {
      providerReady = false;
      if (skeleton) skeleton.hidden = true;
      if (fallback) fallback.hidden = true;
      region.dataset.loyaltyLoadingState = 'loading';
      scheduleFallback();
    }
    update();
  });
}
